module.exports = __webpack_public_path__ + "img/game_phone_th.e976740b.png";